/* TODO: plain-value backwards-compatible logic cleanup follow-up ticket:
 * https://engineering.paypalcorp.com/jira/browse/DTSHOPATMS-2198
 */
import {
  Action,
  ActionHandler,
  ModalContextDispatch
} from '../shoplist-app/shopping/types/ShoppingPageType'
import {
  MODAL_CONTEXT_GOLD_STORE_TERMS_OPEN_ACTION,
  STORE_ID
} from './client-constants'
import { getSearchParams } from './searchParams'

interface HandleModalDispatch {
  modalDispatch?: ModalContextDispatch
  navigationTarget: Action['navigationTarget']
}
type HandleGoldStoreTermsModal = HandleModalDispatch
interface HandleAction {
  actionHandler?: ActionHandler
}

export const handleGoldStoreTermsModal = ({
  modalDispatch,
  navigationTarget
}: HandleGoldStoreTermsModal) => {
  const urlSearchParams = getSearchParams(navigationTarget || '')
  const storeId = urlSearchParams.get(STORE_ID)
  if (storeId && modalDispatch) {
    modalDispatch({
      type: MODAL_CONTEXT_GOLD_STORE_TERMS_OPEN_ACTION,
      payload: { storeId }
    })
  }
}

export const handleAction = ({ actionHandler }: HandleAction) => {
  if (actionHandler) {
    actionHandler()
  }
}
